<template>
  <div>
    <v-combobox
      ref="combobox"
      v-model="internalValue"
      v-bind="$attrs"
      item-text="description"
      item-value="id"
      dense
      clearable
      return-object
      class="font-weight-medium text-body-1"
      :loading="$attrs.isBusy"
      :rules="prepRules()"
      @change="onChange"
    >
      <template v-slot:label>
        <v-icon
          v-if="$attrs.required"
          class="required-icon"
          x-small
        >
          mdi-asterisk
        </v-icon>
        {{ $attrs.label }}
      </template>
    </v-combobox>
  </div>
</template>

<script>
  import { get } from 'vuex-pathify'

  export default {
    name: 'ComboBox',

    props: {
      value: {
        type: Object,
        default: null,
      },
    },

    data () {
      return {
        internalValue: this.value,
      }
    },

    computed: {
      appRules: get('app/rules'),
    },

    watch: {
      internalValue: {
        handler (val, oldVal) {
          this.$emit('input', this.internalValue)
        },
        deep: true,
      },
      value: {
        handler (val, oldVal) {
          this.internalValue = val
        },
        deep: true,
      },
    },

    methods: {
      onChange (dataItem) {
        if (dataItem) {
          if ({}.hasOwnProperty.call(dataItem, 'id')) {
            this.internalValue.id = dataItem.id
          } else {
            this.internalValue = { id: dataItem, description: dataItem }
          }
        }

        this.$nextTick(() => {
          this.$emit('change', dataItem)
        })
      },

      prepRules () {
        const rules = []

        if (this.$attrs.required && !this.$attrs.disabled) {
          rules.push(this.appRules.required)
        }
        rules.push(this.appRules.validOption(this.internalValue, this.$attrs.items, `${this.$attrs.displayAsSingular} does not exist in the list.`))

        return rules
      },
    },
  }
</script>

<style lang="scss" scoped>
.required-icon {
  vertical-align: top;
  color: #dd0000;
}
</style>
